import { gql } from "@/api/utils.js"

const getPlans = gql`
	query plans(
		$limit: Int
		$skip: Int
		$sort: sortInput
		$where: planWhereInput
	) {
		plans(limit: $limit, skip: $skip, sort: $sort, where: $where) {
			name
			createdAt
			id {
				plan
				type
				version
			}
			tags {
				id
				type
			}
		}
	}
`

const getPlanDetail = gql`
	query plans($where: planWhereInput) {
		plans(where: $where) {
			__typename
			id {
				plan
				type
				version
			}
			description
			createdAt
			name
			price {
				amount
				formattedPrice
				currencyCode
				amountLogic
				paymentFrequency
			}
			tags {
				id
				type
			}
		}
	}
`

const createPlan = gql`
	mutation createPlan($input: planInput!) {
		createPlan(input: $input) {
			status
			errors
			errors_2 {
				code
				message
			}
		}
	}
`

const deletePlan = gql`
	mutation deletePlan($id: productIdInput!) {
		deletePlan(id: $id) {
			status
			errors
			errors_2 {
				code
				message
			}
		}
	}
`

const createPlanPriceLogic = gql`
	mutation createPlanPriceLogic(
		$productId: productIdInput!
		$input: priceLogicInput!
	) {
		createPlanPriceLogic(productId: $productId, input: $input) {
			errors
			status
			errors_2 {
				code
				message
			}
		}
	}
`

const updatePlanPriceLogic = gql`
	mutation updatePlanPriceLogic(
		$productId: productIdInput!
		$input: priceLogicInput!
	) {
		updatePlanPriceLogic(productId: $productId, input: $input) {
			errors
			status
			errors_2 {
				code
				message
			}
		}
	}
`

const deletePlanPriceLogic = gql`
	mutation deletePlanPriceLogic($productId: productIdInput!) {
		deletePlanPriceLogic(productId: $productId) {
			errors
			status
			errors_2 {
				code
				message
			}
		}
	}
`

const localizePlan = gql`
	mutation localizePlan($l10n: upsertL10nInput) {
		upsertL10n(l10n: $l10n) {
			errors
			status
		}
	}
`

const deleteAllL10n = gql`
	mutation deleteAllL10n($key: String!) {
		deleteAllL10n(key: $key) {
			errors
			status
		}
	}
`

const addTagToPlan = gql`
	mutation addTagToProduct($productId: productIdInput!, $input: tagInput!) {
		addTagToProduct(productId: $productId, input: $input) {
			status
			errors
		}
	}
`

const removeTagFromPlan = gql`
	mutation removeTagFromProduct($productId: productIdInput!, $id: String!) {
		removeTagFromProduct(productId: $productId, id: $id) {
			status
			errors
		}
	}
`

const query = { getPlans, getPlanDetail }

const mutation = {
	createPlan,
	deletePlan,
	createPlanPriceLogic,
	updatePlanPriceLogic,
	deletePlanPriceLogic,
	localizePlan,
	deleteAllL10n,
	addTagToPlan,
	removeTagFromPlan
}

export { query, mutation }
